/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
/**
 * @param {string} groupName
 * @param rootElement
 * @returns {object}
 */
export default function getGroupedElements(groupName, rootElement = document) {
  const elements = rootElement.querySelectorAll(`[class*='js-${groupName}']`);
  const getElementNameRegexp = new RegExp(`js-${groupName}-(\\w+)`, 'i');
  const group = {};

  Array.from(elements).forEach((element) => {
    const match = element.className.match(getElementNameRegexp);

    if (match) {
      const elementName = match[1];
      group[elementName] = element;
    }
  });

  return group;
}
